module.exports = __webpack_public_path__ + "static/media/JCIcon.5df9dd6c.png";